// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import { VueMasonryPlugin } from 'vue-masonry'
import App from './App'
import router from './router'
import infiniteScroll from 'vue-infinite-scroll' // eslint-disable-line no-unused-vars
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Vant from 'vant';
import { RadioGroup, Radio, Field, Checkbox, CheckboxGroup, Popup, NavBar, Rate } from 'vant';
import 'vant/lib/index.css';
import '../static/css/reset.css';
import 'swiper/dist/css/swiper.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/'
import jwt_decode from "jwt-decode";
import './assets/fonts/iconfonts/iconfont.css';
import '../static/css/readpl.css';
import '../static/css/readptV2.css';
import '../static/css/readptV2.css';

import http from './api/http.js'
import common from "./units/common.js";
// 定义一个工具函数
function preload() {
  var org = common.org.get();
  if (org && org.name) {
    document.title = org.name;
  }


  Vue.use(ElementUI)
  Vue.use(Vant);
  Vue.config.productionTip = false
  Vue.prototype.http = http;
  Vue.prototype.$api = http.api;

  Vue.prototype.$local = http.local;
  Vue.prototype.$cloud = http.cloud;


  Vue.prototype.$com = common;
  Vue.prototype.jwt_decode = jwt_decode;
  Vue.use(infiniteScroll);
  Vue.use(VueAwesomeSwiper);
  Vue.use(VueCompositionAPI)  // 必须在vue-masonry之前注册:ml-citation{ref="3,5" data="citationList"}
  Vue.use(VueMasonryPlugin)
  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(Field);
  Vue.use(Checkbox);
  Vue.use(CheckboxGroup);
  Vue.use(Popup);
  Vue.use(NavBar);
  Vue.use(Rate);
  /* eslint-disable no-new */
  Vue.prototype.$onWait = new Promise((reslove) => {
    Vue.prototype.$reslove = reslove;
  })

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
}
// 清除阅读数据缓存
common.read.remove();
var source = null;

// 自带token链接，小程序跳作品，认证跳系统，活动跳系统
if (source == null && common.getParams().token) {
  source = 'token';
}
// 检查到此参数，表示登录成功，不在重复取信息，该参数只有在登陆成功时添加，使用过后马上销毁
if (common.sys.login.get()) {
  common.sys.login.remove();
  source = "preload";
}
// 微信公众号访问系统
if (source == null && common.wx.platform() && allow()) {
  source = 'decode';
}
switch (source) {
  case 'preload':
    preload();
    break;
  case 'decode':
    if (common.getParams().referrerId) {
      localStorage.setItem('referrerId', common.getParams().referrerId);
    }
    common.wx.decode().then((res) => {
      common.member.oauth.set(res.data.oauth);
      common.member.reset(res.data).then(() => {
        preload();
        var redirect = common.getParams().redirect;
        if (redirect) {
          redirect = decodeURIComponent(decodeURIComponent(redirect));
          if (redirect.indexOf("http://") >= 0 || redirect.indexOf("https://") >= 0) {
            redirect = redirect.replace("http://", "").replace("https://", "");
            redirect = redirect.substring(redirect.indexOf("/"));
          }
          return common.to.path(redirect);
        }
      });
    });
    break;
  default:
    var params = {
      host: location.href,
      token: common.getParams().token || common.token.get(),
      schoolId: common.getParams().schoolId,
      inviteId: common.getParams().inviteId,
      logout: common.sys.logout.get()
    };
    http.api.match(params).then((res) => {
      common.token.remove();
      if (res.code != 1) {
        common.message.alert(res.info);
        return common.to.home(true);
      }
      common.member.reset(res.data).then(() => {
        preload();
        var redirect = common.getParams().redirect;
        if (redirect) {
          redirect = decodeURIComponent(decodeURIComponent(redirect));
          if (redirect.indexOf("http://") >= 0 || redirect.indexOf("https://") >= 0) {
            redirect = redirect.replace("http://", "").replace("https://", "");
            redirect = redirect.substring(redirect.indexOf("/"));
          }
          return common.to.path(redirect);
        }
      });
    });
    break;
}
function allow() {
  return common.getParams().pass ? false : true;
}






// WEBPACK FOOTER //
// ./src/main.js